import { render, staticRenderFns } from "./zhuanti-quyufazhan.vue?vue&type=template&id=70320124&"
import script from "./zhuanti-quyufazhan.vue?vue&type=script&lang=js&"
export * from "./zhuanti-quyufazhan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports